// Copyright (c) StrangeBee 2024

import SsoButton from '@Atoms/Buttons/SsoButton/SsoButton';
import { useLocalMessage } from '@Helpers/locale';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import LoginForm from '@Organisms/Login/LoginForm/LoginForm';
import { Layout, Space } from 'antd';
import { Store } from 'antd/lib/form/interface';
import React, { ReactElement } from 'react';
import { SSOProviderType } from 'thehive-sdk';

import './LoginContent.scss';

const { Content } = Layout;

interface LoginContentProps {
    mfa: boolean;
    hasOauth: boolean;
    onLoginFinish: (values: Store) => void;
    onSsoClick: () => void;
    onClickSSOProvider?: (url: string) => void;
    ssoProviders?: SSOProviderType[];
}

export const LoginContent = ({
    mfa,
    hasOauth,
    onLoginFinish,
    onSsoClick,
    ssoProviders,
    onClickSSOProvider,
}: LoginContentProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <Content className="login-content">
            <Space direction="vertical" size="large" className="login-content__title">
                <span className="login-content__title-text">{i('login.title')},</span>
                <span className="login-content__title-subtext">{i('login.subtitle')}</span>
            </Space>

            <div className="login-content__form">
                <LoginForm onFinish={onLoginFinish} mfa={mfa} />
            </div>

            <div className="login-content__sso">
                <>
                    {hasOauth ? <SsoButton onClick={onSsoClick} /> : null}
                    {ssoProviders?.map(({ name = '', url, displayName }) => (
                        <THButton key={name} block className="sso-button" onClick={() => onClickSSOProvider?.(url)}>
                            {i('login.ssoProvider', { name: displayName || name })}
                        </THButton>
                    ))}
                </>
            </div>
        </Content>
    );
};
